export default __webpack_public_path__ + "static/media/SportKLS_Frente.d29a1577.webp";